module.exports = __webpack_public_path__ + "img/galeria-especie-prioritaria-1.160c61a5.jpg";